<template lang="pug">
div
  #preloader(v-if="gameLaunching || favListAction")
    #loader
</template>
<script>
export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      gameLaunching:false,
      mobileDevice: false
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  created() {
    this.getMobile()
    // var q = this.$route.query;
    this.launchGame();
  },
  methods: {
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    launchGame() {
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let type = (this.mobileDevice ? 2 : 1).toString()
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchWbet", { player_id, auth_token,type, lang_code })
          .then(response => {
            if (response.success == true) {
							window.location.assign(response.data)
            } else {    
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);    
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push("/").catch(error =>{})
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              } 
            }
          });
      }else{
				$("#logModal").modal("show")
			}
    }
  }
}
</script>